<template>
  <div>
    <v-dialog v-model="tahsilatdialog" persistent max-width="500px">
      <v-card color="grey lighten-2">
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">{{dialogbaslik}}</v-toolbar-title>
          </v-toolbar>
        </v-flex>
        <v-card-text>
          <div class="flex md12">
      <tarihcomp :etiket="'Ödeme Tarihi'" v-bind:defaultvalue="'ok'" v-model="val.Tarih"></tarihcomp>
            <v-layout>
              <v-select hide-details="" :items="itemsevraktipi" v-model="val.EvrakCinsi" clearable
                item-text="Aciklama" item-value="Evrakkod" label="Evrak Tipi"></v-select>
              <v-text-field hide-details="" label="Evrak No" v-model="val.EvrakNo" ></v-text-field>
            </v-layout>
            <v-text-field hide-details="" v-model="val.Aciklama" label="Açıklama" ></v-text-field>
            <parainput :etiket="'Tutar'" v-model="val.Tutar" :autocomplete="'autocomplete'"></parainput>
            <v-layout>
              <v-select hide-details="" :items="doviztipi" @change="kurgetir(val.Tarih,val.Doviz)" v-model="val.Doviz"
                clearable  item-text="DovizUnvan" item-value="DovizKod" label="Döviz Tipi"></v-select>
              <parainput :etiket="'Döviz Kuru'" v-model="val.Kur" :autocomplete="'autocomplete'"></parainput>
            </v-layout>
            <dovizinput :etiket="'Döviz Tutar'" v-model="val.DovizTutar" :autocomplete="'autocomplete'"></dovizinput>
            <v-layout>
              <v-autocomplete :items="bankapositems" @change="taksitgetirtahsilat(val.PosKod)" hide-details="" v-model="val.PosKod"
                item-text="Aciklama" item-value="PosKodu" clearable label="Pos Kodu"></v-autocomplete>
              <v-select :items="taksitsayitahsilat" hide-details="" v-model="val.TaksitKod" item-text="TaksitAciklama"
                item-value="TaksitID" clearable label="Taksit"></v-select>
            </v-layout>
            <parainput :etiket="'Puan Tutar'" v-model="val.PuanTutar" :autocomplete="'autocomplete'"></parainput>
            <v-text-field hide-details="" label="Kredi Kart No" v-model="val.KrediKartNo" ></v-text-field>
            <v-select :items="itemsbanka" hide-details="" v-model="val.BankaKod" item-text="BankaAdi" item-value="BankaKod"
              clearable label="Banka Kodu"></v-select>
            <v-autocomplete hide-details tabindex="4"  append-icon="search" label=" Karşı Cari Seçiniz"
              :loading="loading" :items="statecaritahsilat" clearable="" item-text="text" cache-items="" item-value="id"
              v-model="val.KarsiCari" :search-input.sync="searchcaritahsilat"></v-autocomplete>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div v-show="tahsilatguncellebuton === true">
            <v-btn id="bguncelle" color="blue darken-1" flat @click="tahsilatguncelle()">Güncelle</v-btn>
          </div>
          <v-btn color="blue darken-1" flat @click.native="tahsilatdialog=false">VazgeÇ</v-btn>
          <div v-show="kaydetbuton===true">
            <v-btn id="bkaydet" color="blue darken-1" flat @click="tahsilatkaydet()">Kaydet</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
        :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tarihcomp from '../../customcomp/tarihim'
  import parainput from '@/components/app/customcomp/parainput.vue'
  import dovizinput from '@/components/app/customcomp/dovizinput.vue'

  export default {
    props: ["value"],
    components: {
      tarihcomp,
      parainput,
      dovizinput
    },
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    beforeMount: beforeMount,

    methods: {
      kurgetir(tarih, kod) {
        var params1 = {
          Tarih: tarih,
          DovizKod: kod
        }

        if (tarih != null && tarih != '') {
          this.$http.post(auth.API_URL + 'api/Helpers/GetRate', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.val.Kur = response.body
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-Kur Hesapla'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-Kur Hesapla'
              this.snackbar = true
            }
          })
        }

      },
      taksitgetirtahsilat(v) {
        var tumliste = []
        tumliste = this.bankapositems
        tumliste.forEach(element => {
          if (element.PosKodu == v) {
            this.taksitsayitahsilat = []
            this.taksitsayitahsilat = element.Taksitler
          }
        });
      },
      open(title) {
        if (title == 'tahsilat') {
          this.dialogbaslik = 'Tahsilat Ekle'
          this.kaydetbuton=true
          this.tahsilatguncellebuton=false
        }

        if (title == 'update') {
          this.dialogbaslik = 'Tahsilat Güncelle'
          this.tahsilatguncellebuton = true
          this.kaydetbuton=false

          var seciliitems = [{
            text: this.val.KarsiCari,
            id: this.val.KarsiCari
          }]
          this.statecaritahsilat = seciliitems
        }

        this.tahsilatdialog = true;
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });

      },
      carigetir2: carigetir2,
      tahsilatkaydet: tahsilatkaydet,
      tahsilatguncelle:tahsilatguncelle
    },
    data() {
      return {
        dialogbaslik: '',
        resolve: null,
        kaydetbuton:false,
        tahsilatguncellebuton: false,
        k: null,
        doviztipi: [],
        reject: null,
        bankapositems: [],
        itemsbanka: [],
        statecaritahsilat: [],
        itemsevraktipi: [],
        tahsilatdialog: false,
        text1: null,
        searchcaritahsilat: '',
        taksitsayitahsilat: [],
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },

    watch: {
      searchcaritahsilat(val) {
       val && this.carigetir2(val)
      },

    },
  }


  function tahsilatkaydet() {
    var paramstahsilat = this.val
    this.$http.post(auth.API_URL + 'api/Payment/DetailPaymentAdd', paramstahsilat, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true
      this.tahsilatdialog = false
      this.resolve(true);
    }, (response) => {
      if (response.status === 0) {
        this.resolve(false);
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.resolve(false);
        this.text1 = response.body.StatusText
        this.snackbar = true
      }
    })
  }

  function beforeMount() {



  }

  function carigetir2(v) {

    this.statecaritahsilat = []

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      q: escape(v),
      c: credentials.SirketKodu
    }
    if (v.length >= 1) {
      this.loading = true
      this.$http.post(auth.API_URL + 'api/options/CurrentSearch', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.statecaritahsilat = response.body
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
      this.loading = false
    }
  }

  function tahsilatguncelle() {

    var paramstahsilat = this.val

    this.$http.post(auth.API_URL + 'api/Payment/DetailPaymentUpdate', paramstahsilat, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true
      this.tahsilatdialog = false
      this.resolve(true);

    }, (response) => {
      if (response.status === 0) {
        this.resolve(false);

        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.resolve(false);
        this.text1 = response.body.StatusText
        this.snackbar = true
      }
    })


  }
</script>